import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export type Colors = keyof typeof colors

export const root = (theme: Theme) => css`
  cursor: pointer;
  display: block;
  padding: 0;
  outline: none;
  background: transparent;
  border: 1px solid transparent;

  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
    outline: none;
    background: transparent;
    border: 1px solid transparent;
  }

  &[disabled] {
    color: ${theme.palette.neutral[600]};
    pointer-events: none;
  }
`

export const colors = {
  primary: (theme: Theme) => css`
    color: ${theme.palette.action[500]};
  `,
  secondary: (theme: Theme) => css`
    color: ${theme.palette.additionalColor.purple[500]};
  `,
  warning: (theme: Theme) => css`
    color: ${theme.palette.warning[500]};
  `,
  negative: (theme: Theme) => css`
    color: ${theme.palette.error[500]};
  `,
  neutral: (theme: Theme) => css`
    color: ${theme.palette.neutral[800]};
  `,
}

export const fullWidth = css`
  width: 100%;
`
